import * as React from 'react';
import { cn } from 'fc/lib/utils';

interface RadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <div className={cn('flex items-center', className)}>
        <input
          type="radio"
          ref={ref}
          className="mr-2 h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          {...props}
        />
        <label className="text-sm font-semibold text-gray-700">{label}</label>
      </div>
    );
  }
);

RadioButton.displayName = 'RadioButton';

export { RadioButton };
